import {Component} from '@angular/core';
import {BaseComponent} from "../base/base.component";
import {MenuPlanLinkXBVO} from "../model/xbvo.model";
import {RestClient} from "../rest-client.service";
import {DateUtilsBs} from "../base/utils/dateUtilsBs";
import {DomSanitizer} from '@angular/platform-browser';

/**
 * App-Component
 */
@Component({
    selector: '<skitbs-menuplans>',
    template: `
        <skitbs-template [title]="v('menu_menuplans')">
            <p-table [value]="modelLiknks" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Zeitraum</th>
                        <th>Erstellt</th>
                        <th>Format</th>
                        <th>Datei</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-pLink>
                    <tr>
                        <td class="TexAlCenter">{{formatDateRange(pLink)}}</td>
                        <td class="TexAlCenter">{{dateFormat(pLink.fileDate, 'dd.MM.')}}</td>
                        <td class="TexAlCenter">PDF</td>
                        <td class="TexAlCenter"><a (click)="onPdfDownload(pLink)"><i class="pi pi-download"></i></a></td>
                    </tr>
                </ng-template>
            </p-table>
        </skitbs-template>
    `
})
export class MenuPlansComponent extends BaseComponent {

    modelLiknks: MenuPlanLinkXBVO[] = [];

    constructor(private restClient: RestClient) {
        super();
    }

    /**
     * Lifecycle.
     */
    ngOnInit(): void {
        let pToday = new Date();
        let pStartDate = DateUtilsBs.addDays(pToday, -7);
        this.restClient
            .menuPlanLinks(DateUtilsBs.getYear(pStartDate), DateUtilsBs.getWeek(pStartDate))
            .subscribe(aXBVO => this.modelLiknks = aXBVO.link);
    }

    /**
     * Action.
     * @param aLink
     * @private
     */
    public onPdfDownload(aLink: MenuPlanLinkXBVO) {
        this.restClient
            .menuplanPDF(aLink.year, aLink.week)
            .subscribe(aBlob => {
                let pFilename = "Menueplan_KW" + aLink.week + "/" + aLink.year + "_" + aLink.fileName;
                this.fileDownload(aBlob, pFilename);
            });
    }

    /**
     * Formats.
     * @param aLink
     * @private
     */
    public formatDateRange(aLink: MenuPlanLinkXBVO): string {
        let pWeekStartEndDate = DateUtilsBs.getWeekStartEndDate(aLink.year, aLink.week);
        return DateUtilsBs.format(pWeekStartEndDate[0], 'dd.MM') + " - " + DateUtilsBs.format(pWeekStartEndDate[1], 'dd.MM');
    }
}
